// extracted by mini-css-extract-plugin
module.exports = {"pdfDrawerCross":"style_pdfDrawerCross__yy25m","pdfDrawerCrossCont":"style_pdfDrawerCrossCont__cp1mb","pdfViewerActions":"style_pdfViewerActions___RdlT"};